import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type CartItem = {
  id: string
  supplierBusinessId: string
  supplierName: string
  price: number
  quantity: number
  variantId: string
  variantParentId: string
  [key: string]: any
}

export interface ICart {
  items: CartItem[]
}

const initialState: ICart = {
  items: [],
}

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, { payload }: PayloadAction<CartItem>) => {
      const existingIndex = state.items.findIndex(
        (item) => item.id === payload.id && item.supplierBusinessId === payload.supplierBusinessId
      )
      if (existingIndex >= 0) {
        state.items[existingIndex].quantity += 1
      } else {
        state.items.push(payload)
      }
    },
    updateQuantity: (
      state,
      { payload }: PayloadAction<{ productId: string; supplierBusinessId: string; quantity: number }>
    ) => {
      if (payload.quantity <= 0) {
        state.items = state.items.filter(
          (item) => !(item.id === payload.productId && item.supplierBusinessId === payload.supplierBusinessId)
        )
      } else {
        const item = state.items.find(
          (item) => item.id === payload.productId && item.supplierBusinessId === payload.supplierBusinessId
        )
        if (item) {
          item.quantity = payload.quantity
        }
      }
    },
    removeFromCart: (
      state,
      { payload }: PayloadAction<{ productId: string; supplierBusinessId: string }>
    ) => {
      state.items = state.items.filter(
        (item) => !(item.id === payload.productId && item.supplierBusinessId === payload.supplierBusinessId)
      )
    },
    clearCart: (state) => {
      state.items = []
    },
    // The price engine prices a line by its quantity (TIER promotions), so the
    // catalogue re-prices cart lines at their cart quantity and writes the
    // result back here; the drawer and checkout read item.price.
    updatePrice: (
      state,
      { payload }: PayloadAction<{ productId: string; supplierBusinessId: string; price: number }>
    ) => {
      const item = state.items.find(
        (item) => item.id === payload.productId && item.supplierBusinessId === payload.supplierBusinessId
      )
      if (item && payload.price > 0) {
        item.price = payload.price
      }
    },
  },
})

export const cartReducer = cartSlice.reducer

export const { addToCart, updateQuantity, removeFromCart, clearCart, updatePrice } = cartSlice.actions
